var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSzambelanOkresow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M48 58.667H37.333v10.666H48V58.667zm21.333 0H58.667v10.666h10.666V58.667zm21.334 0H80v10.666h10.667V58.667zm10.666-37.334H96V10.667H85.333v10.666H42.667V10.667H32v10.666h-5.333c-5.92 0-10.614 4.8-10.614 10.667L16 106.667c0 5.866 4.747 10.666 10.667 10.666h74.666c5.867 0 10.667-4.8 10.667-10.666V32c0-5.867-4.8-10.667-10.667-10.667zm0 85.334H26.667V48h74.666v58.667z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 116,
    r: 116,
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#979797",
    strokeWidth: 8,
    d: "M0 116c0 64.065 51.935 116 116 116s116-51.935 116-116S180.065 0 116 0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.384,
    transform: "translate(52 52)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillOpacity: 0.38,
    fillRule: "nonzero",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h128v128H0z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzambelanOkresow);
export default __webpack_public_path__ + "static/media/szambelan_okresow.e2b27173af70a545f6c0e89b2447f46a.svg";
export { ForwardRef as ReactComponent };